import React, { useState, useEffect, useCallback, useRef } from 'react';
import './competition_entry_send.scss';
import ScrollView from 'devextreme-react/scroll-view';
import { Item, Toolbar } from 'devextreme-react/toolbar';

import Button from 'devextreme-react/button';

import notify from 'devextreme/ui/notify';
import { getApiToken } from '../../utils/authUtils.js';

import { useNavigate, useParams } from 'react-router-dom';
import { withLoadPanel } from '../../utils/withLoadPanel';

import axios from 'axios';
import { CompetitionSendClubDetails, CompetitionSendForm } from '../../components';
import { useMsal } from "@azure/msal-react";



export const CompetitionEntrySend = () => {
      const { instance, accounts } = useMsal();
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [problems, setProblems] = useState([]);
    let sendData;
    const gridRef = useRef(null);
    const navigate = useNavigate();
    let { competitionId } = useParams()
    const CompetitionSendClubDetailsWithLoadPanel = withLoadPanel(CompetitionSendClubDetails);

    useEffect(() => {
        getApiToken(instance, accounts).then((token) => {
            axios.get(`${process.env.REACT_APP_serverEndpoint}/Entry/GetClubsEntries?competitionId=` + competitionId, {
                headers: {
                    'Authorization': "Bearer " + token,
                }

            })
                .then((response) => {
                    if (response.data.success) {
                        setData(response.data.result_set); // Clubs in setGridDataSource übernehmen
                        setIsLoading(false);
                        sendData = response.data.result_set; // sendData initialisieren
                        // Probleme extrahieren und speichern
                        if (response.data.result_set.problems && Array.isArray(response.data.result_set.problems) && response.data.result_set.problems.length > 0) {
                            setProblems(response.data.result_set.problems);
                        } else {
                            setProblems([]);
                        }
                    } else {
                        notify({
                            message: 'Fehler beim Abrufen der Daten.',
                            position: { at: 'bottom center', my: 'bottom center' },
                        }, 'error');
                    }
                })
                .catch((error) => {
                    console.error('Fehler beim Abrufen der Daten:', error);
                    notify({
                        message: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
                        position: { at: 'bottom center', my: 'bottom center' },
                    }, 'error');
                });
        });
    }, [competitionId]);
    const onDataChanged = useCallback((e) => {
        sendData = e;
    }, []);

    const onSendClick = useCallback(() => {
        setData(sendData);
        setIsLoading(true);
        getApiToken(instance, accounts).then((token) => {
            axios.post(`${process.env.REACT_APP_serverEndpoint}/Entry/SendEntries`, 
                sendData  // Übergebe die competitionId als Payload
            , {
                headers: {
                    'Authorization': "Bearer " + token,
                },
            })
                .then((response) => {
                    if (response.data.success) {
                        notify({
                            message: 'Meldungen wurden erfolgreich versendet.',
                            position: { at: 'bottom center', my: 'bottom center' },
                        }, 'success');
                        setIsLoading(false);
                        navigate(-1); // Navigiere zurück zur vorherigen Seite
                    } else {
                        notify({
                            message: 'Fehler beim Versenden der Meldungen.',
                            position: { at: 'bottom center', my: 'bottom center' },
                        }, 'error');
                        setIsLoading(false);
                    }
                })
                .catch((error) => {
                    console.error('Fehler beim Versenden der Meldungen:', error);
                    notify({
                        message: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
                        position: { at: 'bottom center', my: 'bottom center' },
                    }, 'error');
                    setIsLoading(false);
                });
        });
    }, [competitionId]);
    const onLeftClick = () => {
        navigate(-1);
    };
    return (

        <ScrollView className='view-wrapper-scroll'>
            <div className='view-wrapper view-wrapper-competition-details'>
                <Toolbar className='toolbar-details theme-dependent'>
                    <Item location='before'>
                        <Button icon='arrowleft' stylingMode='text' onClick={onLeftClick} />
                    </Item>
                    <Item location='before' text={function () {
                        if (!!data) {

                            return data?.competitionName
                        } else {
                            return 'Lädt...'
                        }

                    }} />

                    <Item location='after'>
                        <Button
                            text='Meldungen versenden'
                            stylingMode='contained'
                            dropDownOptions={{ width: 'auto' }}
                            onClick={onSendClick}
                            type='default'

                        />
                    </Item>

                </Toolbar>

                <CompetitionSendClubDetailsWithLoadPanel
                    loading={isLoading}
                    hasData={!!data}
                    data={data}
                    onDataChanged={onDataChanged}
                    problems={problems}
                    competitionId={competitionId}
                />


            </div>
        </ScrollView>

    );
};

